import React, { ChangeEvent } from "react";
import { Icon } from "../Icon";
import { Checkbox } from "../Checkbox";
import { Box, BoxProps, Typography, Button } from "@mui/material";

/**
 * 사이드 패널의 서브 헤더 — "총 이슈" 라벨 + 전체선택 체크박스 + 필터 버튼.
 *
 * 현재 이슈 목록 사이드 패널 전용 레이아웃 (재사용 시 컨텍스트 확인).
 */
export interface SideSubProps extends BoxProps {
  checked: boolean;
  onFilterClick: () => void;
  onCheckboxChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const SideSub = React.forwardRef<HTMLDivElement, SideSubProps>(
  ({ checked = false, onCheckboxChange, onFilterClick, ...props }, ref) => {
    return (
      <Box ref={ref} {...props} sx={container}>
        <Typography variant="body2" fontWeight="medium">
          총 이슈
        </Typography>
        <Box sx={buttons}>
          <Checkbox
            size="medium"
            intent="primary"
            checked={checked}
            onChange={onCheckboxChange}
          />
          <Button
            sx={filterButton}
            onClick={onFilterClick}
            endIcon={<Icon name="16/etc/filter" size={16} />}
          >
            필터
          </Button>
        </Box>
      </Box>
    );
  }
);

SideSub.displayName = "SideSub";

const container = {
  width: "100%",
  maxWidth: 320,
  height: 64,
  padding: "8px 8px 8px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
} as const;

const buttons = {
  display: "flex",
  alignItems: "center",
  gap: 1,
} as const;

const filterButton = {
  minWidth: 70,
  height: 40,
  padding: "4px 8px",
  fontSize: "12px",
  color: "rgba(0, 0, 0, 0.60)",
  textTransform: "none",
  border: "1px solid #e0e0e0",
  backgroundColor: "#ffffff",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
} as const;
